import React from "react";

export default function TobSubtitle(props) {
  return <div className="top-subtitle-container">{props.text}</div>;
}
